import type { ICategory } from "app/common/services/categoryService.types";
import type { IDomains, IDomainsList } from "pro-features/components/DomainsFilter/Types";
import { transformDomainsData } from "pro-features/components/DomainsFilter/Utils";
import { DefaultFetchService } from "app/services/fetchService";
import Sentry from "@similarweb/sentry-logger";

const fetchService = DefaultFetchService.getInstance();

export const getCategories = async (api: string, paramsAsString): Promise<ICategory[]> => {
    try {
        const categories: ICategory[] = await fetchService.get(`${api}?${paramsAsString}`);
        return categories;
    } catch (err) {
        Sentry.error(`Error fetching categories`, err);
    }
};

export const getDomains = async (api: string, params): Promise<IDomainsList[]> => {
    try {
        const domains: IDomains[] = await fetchService.get(`${api}?${params}`);
        return transformDomainsData(domains);
    } catch (err) {
        Sentry.error(`Error fetching domains`, err);
    }
};
